export default "__VITE_ASSET__2e5001d8__"